import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";

const { innerWidth: width, innerHeight: height } = window;

const CustomerSubscription = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { customerData, storeCustomerId, storeIdValue } = location.state || {}; // Fallback to prevent undefined errors


  // const { storeData } = getUserData();

  // const enabledOldOrderFeature = storeData.enabledOldOrderFeature;

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/WalletLedgerSelection", {
                      state: {
                        customerData: customerData,
                        storeCustomerId: storeCustomerId,
                        storeId: storeIdValue,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Subscription
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1">
        <div className="flex flex-1 flex-row">
          <div
            className="flex flex-1 flex-column justify-content-center align-items-center cursor-pointer"
            onClick={() =>
              navigate("/CustomerPackageOffer", {
                state: {
                  customerData: customerData,
                  storeCustomerId: storeCustomerId,
                  storeIdValue: storeIdValue,
                },
              })
            }
            style={{ flex: 1, alignSelf: "center" }}
          >
            <img
              src={"Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif"}
              style={{
                alignSelf: "center",
                transform: [{ scaleX: 1 }],
                resizeMode: "contain",
                width: height < 600 ? "17%" : "20%",
              }}
            />
            <div className="my-3">
              <p className="text-4xl font-bold" style={{ color: "#2B70D7" }}>
                Package Offers
              </p>
            </div>
          </div>
          <div
            className="my-5 flex flex-1 flex-column justify-content-center align-items-center cursor-pointer"
            onClick={() =>
              navigate("/Customer-Package-Log", {
                state: {
                  storeCustomerId: storeCustomerId,
                  customerData: customerData,
                  storeIdValue: storeIdValue,
                },
              })
            }
            style={{ display: "flex", flex: 1, alignSelf: "center" }}
          >
            <img
              src={"Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif"}
              style={{
                alignSelf: "center",
                transform: [{ scaleX: 1 }],
                resizeMode: "contain",
                width: height < 600 ? "17%" : "20%",
              }}
            />
            <div className="my-3">
              <p className="text-4xl font-bold" style={{ color: "#2B70D7" }}>
                Package Booking
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSubscription;
